<script lang="ts">
	import { beforeUpdate } from 'svelte';
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_control_component_channel_structure,
		is_gen_2,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Design System Components
	// Components
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import TimerRemaining from 'src/components/TimerRemaining/TimerRemaining.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];
	const isGen2 = is_gen_2(device);

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	// Status and label processing
	$: _statuses = status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: labelList = Array.isArray(_statuses)
		? _statuses.filter((e) => {
				return 'undefined' === typeof e.main && e.name !== 'state';
			})
		: [];
	$: combinedLabelList = [...Object.values(timerLabels), ...labelList];

	let timerLabels: Record<string, any> = {};
	let timer = false;

	beforeUpdate(() => {
		if (status?.online && deviceConfig) {
			timer =
				isGen2 && status?.[`${get_gen_2_component_channel_structure(device)}`]?.timer_started_at;
		}
	});
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		{#if timer}
			{#key status[get_gen_2_control_component_channel_structure(device)].timer_started_at}
				<TimerRemaining timerKey="gen2_main" {device} {status} {settings} bind:timerLabels />
			{/key}
		{/if}
		<DeviceLabelList labelList={combinedLabelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
</DeviceViewStateWrapper>
